import React from 'react';
import UnifiedMessageCustomerModal from './UnifiedMessageCustomerModal';
import { sendWhatsAppToCustomer } from '../../../services/BackendService';
import { ICustomer } from '../types';

interface IProps {
  show: boolean;
  onClose: () => void;
  onCloseDiscardChanges: () => void;
  customer: ICustomer;
}

const WhatsAppCustomerModal = ({ show, onClose, onCloseDiscardChanges, customer }: IProps) => {
  return (
    <UnifiedMessageCustomerModal
      show={show}
      onClose={onClose}
      onCloseDiscardChanges={onCloseDiscardChanges}
      customer={customer}
      titleKey="customer.send-whatsapp-to"
      successToastKey="customer.whatsapp-sent-to-customer"
      inputId="whatsapp-message"
      showSubject={false}
      onSend={({ customerId, message }) => sendWhatsAppToCustomer(customerId, message)}
    />
  );
};

export default React.memo(WhatsAppCustomerModal);
